// Eventstatus
export const EVENT_STATUS_NORMAL = 1
export const EVENT_STATUS_UPCOMING = 2
export const EVENT_STATUS_HAPPENING = 3
export const EVENT_STATUS_ENDED = 4
export const EVENT_STATUS_CANCELED = 5
